import React from 'react'

export default function ErrorView() {
  return <center><h1> NOT FOUND 404</h1></center>
}
